@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/common" as c;

.search {
  width: 100%;
  flex: 0 0 5%;
  gap: 4px;

  .searchBtn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 52px;
    height: 48px;
    padding: 0;
    border-radius: 10px;
    background-color: v.$palette-sea-tracking;
    color: v.$palette-pure-white;

    &.searchBtnAir {
      background-color: v.$palette-air-tracking;
    }

    &.searchBtnGlobal {
      background-color: v.$palette-global-tracking;
    }

    &:disabled,
    &:disabled:hover,
    &:disabled:focus,
    &:disabled:active {
      background-color: v.$palette-sea-tracking;
      color: v.$palette-pure-white;
      cursor: not-allowed;
    }

    &.searchBtnAir:disabled,
    &.searchBtnAir:disabled:hover,
    &.searchBtnAir:disabled:focus,
    &.searchBtnAir:disabled:active {
      background-color: v.$palette-air-tracking;
    }

    &.searchBtnGlobal:disabled,
    &.searchBtnGlobal:disabled:hover,
    &.searchBtnGlobal:disabled:focus,
    &.searchBtnGlobal:disabled:active {
      background-color: v.$palette-global-tracking;
    }

    svg {
      width: 22px;
      height: 22px;

      path {
        fill: v.$palette-pure-white;
      }
    }

    @include c.containerMedia(v.$tablet-breakpoint) {
      width: 100%;
      svg {
        display: none;
      }
    }

    .searchBtnText {
      display: none;
      @include t.text(16px, 26px, 500);
      @include c.containerMedia(v.$tablet-breakpoint) {
        display: block;
      }
    }
  }

  .form {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-grow: 1;
    background: v.$palette-white;
    border-radius: 16px;
    box-shadow: v.$shadow-2;
    padding: 4px;
    gap: 4px;

    @include c.containerMedia(v.$tablet-breakpoint) {
      background-color: transparent;
      flex-direction: column;
      align-items: stretch;
      box-shadow: none;
      gap: 8px;
    }

    &.loading {
      input {
        pointer-events: none
      }

      .searchBtn {
        padding: 0;
        cursor: not-allowed;
      }
    }

    .inputContainer {
      padding-right: 4px;
      flex-grow: 1;

      input {
        font-family: v.$primary-font;
        @include t.text(18px, 20px, 500);
        height: 48px;
        border-radius: 6px;
        transition: all 0.2s;
        width: 100%;
        padding-left: 16px;
        box-sizing: border-box;
        border: 2px solid transparent;
        overflow: hidden;
        text-overflow: ellipsis;
        background-color: v.$palette-white;
        color: v.$palette-gray-900;

        &::placeholder {
          color: v.$palette-gray-400;
          user-select: none;
        }

        &:focus {
          border-color: v.$palette-blue;
          box-shadow: v.$shadow-3;

          &.error {
            border-color: v.$palette-red;
            box-shadow: 0 0 0 2px #ffe0e8;
          }
        }

        &:disabled {
          background-color: transparent;
        }
      }

      @include c.containerMedia(v.$tablet-breakpoint) {
        padding: 0;
        width: 100%;

        input {
          border-radius: 16px;
          box-shadow: v.$shadow-2;
          background-color: v.$palette-white;
        }
      }
    }
  }

  .message {
    margin: 4px;
    padding: 13px 16px;
    background-color: v.$palette-red-light;
    border-radius: 16px;
    color: v.$palette-red;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .iconWrapper {
      svg {
        filter: drop-shadow(0px 3px 12px rgba(245, 44, 92, 0.53));
      }
    }

    .text {
      margin-left: 16px;
    }
  }
}
